/** 그리드 형상 서명. 바뀌면 기존 시드가 다른 판이 되므로 재현 키에 포함한다. */
export const GRID_VERSION = 1;

const COLS = 11;
const ROWS = 18;

export const GRID = {
  COLS,
  ROWS,
  CELL_COUNT: COLS * ROWS, // 파생 — 리터럴 금지
} as const;

export type CellIndex = number; // 0 .. 197
export interface Cell {
  readonly x: number;
  readonly y: number;
}

/** 0=UP 1=RIGHT 2=DOWN 3=LEFT (시계방향). 문자열 유니온 금지 — 정렬·해시가 불안정하다. */
export type Dir = 0 | 1 | 2 | 3;
export const DIR = { UP: 0, RIGHT: 1, DOWN: 2, LEFT: 3 } as const;
export const DIR_VEC: readonly (readonly [number, number])[] = [
  [0, -1],
  [1, 0],
  [0, 1],
  [-1, 0],
];

export function isOpposite(a: Dir, b: Dir): boolean {
  return ((a + 2) & 3) === b;
}

export function cellToIndex(x: number, y: number): CellIndex {
  return y * COLS + x;
}
export function indexToX(i: CellIndex): number {
  return i % COLS;
}
export function indexToY(i: CellIndex): number {
  return (i / COLS) | 0;
}
export function indexToCell(i: CellIndex): Cell {
  return { x: indexToX(i), y: indexToY(i) };
}
export function isInside(x: number, y: number): boolean {
  return x >= 0 && x < COLS && y >= 0 && y < ROWS;
}

/** 진행 방향으로 한 칸. 밖으로 나가면 -1 (= 벽 충돌). */
export function stepIndex(i: CellIndex, d: Dir): CellIndex {
  const v = DIR_VEC[d] as readonly [number, number];
  const x = indexToX(i) + v[0];
  const y = indexToY(i) + v[1];
  return isInside(x, y) ? cellToIndex(x, y) : -1;
}

export function manhattan(a: CellIndex, b: CellIndex): number {
  return Math.abs(indexToX(a) - indexToX(b)) + Math.abs(indexToY(a) - indexToY(b));
}

export function chebyshev(a: CellIndex, b: CellIndex): number {
  return Math.max(Math.abs(indexToX(a) - indexToX(b)), Math.abs(indexToY(a) - indexToY(b)));
}

/** 그리드 안의 4-이웃만. 길이 2~4. */
export function neighbors4(i: CellIndex, out: number[]): number[] {
  out.length = 0;
  for (let d = 0 as Dir; d < 4; d = (d + 1) as Dir) {
    const n = stepIndex(i, d);
    if (n >= 0) out.push(n);
  }
  return out;
}
